
import './styles.css'
import React from 'react';

function NotFound() {

 
    return (
        <div className='component-wrapper'>
        <div className='notfound-container'>
        <h1>404! Page Not Found</h1>
        <a href='/setu_beta_frontend'>Go Back</a>
        </div>
      
           
        </div>
    )
}

export default NotFound
